import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SyncIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M22 2a1 1 0 1 0-2 0v3.75l-1.33-1.2A10 10 0 0 0 2 12a1 1 0 1 0 2 0 8 8 0 0 1 13.33-5.96L18.4 7H15a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V2ZM2 16a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H5.6l1.07.95A8 8 0 0 0 20 12a1 1 0 0 1 2 0 10 10 0 0 1-16.67 7.45L4 18.24V22a1 1 0 1 1-2 0v-6Z" />
  </Icon>
));
export default SyncIcon;
